import * as React from 'react';
import './championwithhealthbar.css';
import Player from "../../fbobjects/Player";
import SimPlayer from "../../fbobjects/calculation/SimPlayer";


interface ChampionWithHealthBarCProps{
    champName:string;
    damage:number;
    percent:number;
    ownerColor:string; //red or blue
    level:number;
    target:Player;
}

export default class ChampionWithHealthBarC extends React.Component<ChampionWithHealthBarCProps,any> {

    constructor(props:ChampionWithHealthBarCProps){
        super(props);

    }

    gp():ChampionWithHealthBarCProps{
        return this.props;
    }

    convertChampName(champName){
        return champName.split(`'`).join("").split(" ").join("");
    }

    renderHealth(){
        // 1px of each: E66868 C15757 974444 723333
        let percentHealth = this.gp().percent;
        let healthBarImageWidth = 104; //104 pixels to fit with padding in the 110px width health bar image
        let scaledHealthBarWidth = Math.round(healthBarImageWidth * percentHealth);

        return <div className="champion-health-block" style={{width:scaledHealthBarWidth}}>
            <div className="first-block"/>
            <div className="second-block"/>
            <div className="third-block"/>
        </div>

    }

    renderTraces(){
        let tracesToRender = [];
        let percentHealth = this.gp().percent;
        let champHealth = this.gp().damage;
        // let maxHealth = Math.round(champHealth / percentHealth);
        let targetPlayer = SimPlayer.createFromPlayer(this.gp().target, this.gp().level);
        let maxHealth = targetPlayer.getInfo().H;
        let healthBarImageWidth = 104;
        let healthInHundreds = maxHealth / 100;
        let scaledHealthBarWidth = Math.round(healthBarImageWidth * percentHealth);
        let widthOfEachBar = Math.round(healthBarImageWidth / healthInHundreds);
        let traceCount = 1;
        for (let i = 0; i < scaledHealthBarWidth; i++) {
            if (i % widthOfEachBar == 0 && i != 0){
                if (traceCount != 10){
                    tracesToRender.push(<div className="champion-trace-block" style={{visibility:"visible"}} key={i}/>);
                    traceCount++;
                }
                else if (traceCount % 10 == 0){
                    tracesToRender.push(<div key={i} className="champion-full-trace-block"></div>);
                    traceCount++
                }
            }

            else{
                tracesToRender.push(<div className="champion-trace-block" key={i}/>)
            }
        }
        return tracesToRender;
    }

    renderMana(){
        // top: 1px #69B6FF | bottom: 2px #4B9BEE
        let manaBarImageWidth = 104; //in pixels
        return <div className="champion-mana-block" style={{width:manaBarImageWidth}}>
            <div className="first-block"/>
            <div className="second-block"/>
        </div>
    }

    renderLevel(){
        let level = this.gp().level.toString();
        let levelToRender = [];
        for (let i = 0; i < level.length; i++) {
            let levelUnit = level[i];
            levelToRender.push(<img key={i} className="champion-level-block" src={'/images/numbers/' + levelUnit + '.png'}/>)
        }
        return levelToRender;
    }

    render(){
        const manaBarBlock = '/images/bars/manaBar.png';
        const healthBarBlock = '/images/bars/healthBars/' + this.gp().ownerColor + '/healthBar.png';
        const levelBar = '/images/bars/healthBars/' + this.gp().ownerColor + '/levelBar.png';
        const championImage = '/images/champions/' + this.convertChampName(this.gp().champName) +'/'+ this.convertChampName(this.gp().champName) + '_E.png';
        return(
            <div className="champion-preview-container">
                <div className="champion-bar">

                    <div className="champion-health-mana">
                        <div className="champion-health-bar">
                            <img src={healthBarBlock}/>
                            <div className="champion-traces">
                                {this.renderTraces()}
                            </div>
                            <div className="champion-health">
                                {this.renderHealth()}
                            </div>

                        </div>
                        <div className="champion-mana-bar">
                            <img src={manaBarBlock}/>
                            <div className="champion-mana">
                                {this.renderMana()}
                            </div>
                        </div>
                    </div>
                    <div className="champion-level-container">
                        <div className="champion-level">
                            {this.renderLevel()}
                        </div>
                        <img className="champion-level-image" src={levelBar}/>
                    </div>
                </div>

                <img className="champion" src={championImage}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/ChampionWithHealthBarC/index.tsx